<modal class="h-modal pnp-deposite" id="pnpDepositModal">
  <div class="h-modal__rightside h-modal__mobile--fixed slideInRight">
    <div class="h-modal__header">
      <div class="h-modal__header--inner flex_spacebetween">
        <h2 class="h-modal--title">
          <!-- <span *ngIf="callingFrom === 'deposit' ">{{'cryptoCashier.cryptoHeading' | translate}}</span>
          <span *ngIf="callingFrom == 'login' || transactionType=='LOGIN'">{{'cryptoCashier.cryptoHeadingLogin' | translate}}</span> -->

          

          <!-- Brite -->
          <span *ngIf="callingFrom === 'deposit' && !(isSemiPnp || isZimplerPnp)">{{'britePlayCashier.britePlayHeadingDeposit' | translate}}</span>
          <span *ngIf="callingFrom === 'withdraw' && !(isSemiPnp || isZimplerPnp)">{{'britePlayCashier.britePlayHeadingWithdraw' | translate}}</span>
          <span *ngIf="(callingFrom == 'login' || transactionType=='LOGIN')&& callingFrom !='deposit' && !(isSemiPnp || isZimplerPnp)">{{'britePlayCashier.britePlayHeadingLogin' | translate}}</span>

          <!-- Zimpler -->
          <span *ngIf="callingFrom === 'deposit' && (isSemiPnp || isZimplerPnp)">{{'zimplerPlayCashier.zimplerPlayHeadingDeposit' | translate}}</span>
          <span *ngIf="callingFrom === 'withdraw' && (isSemiPnp || isZimplerPnp) ">{{'zimplerPlayCashier.zimplerPlayHeadingWithdraw' | translate}}</span>
          <span *ngIf="(callingFrom == 'login' || transactionType=='LOGIN') && (isSemiPnp || isZimplerPnp)">{{'zimplerPlayCashier.zimplerPlayHeadingLogin' | translate}}</span>

        
        </h2>
        <div class="h-modal--close" (click)="closePNPModal()">
          <span class="close-mark" ></span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="paymentProcessStep === 'semiPnpFlow'">
      <div class="h-modal__with_footer">
        <div class="h-modal__body">
         <app-create-account-pnp (goToZimplerIfram)="callZimplerInit($event)"></app-create-account-pnp>
     </div>
     </div>
     <div class="h-modal__footer flex_verticalalign flex_justifyCenter pnpflow">
      <div class="text-center">
          <button type="button" id="registerZimplerUser" (click)="registerUser()"
              class="updateprf_changebtn btn-new site-btn site-btn__primary site-btn--lg">
              <span>{{'pnpNewflow.createAnAccount' | translate}}</span>
          </button>
          <!-- <div class="pnpSwFlow--resetlink"  *ngIf="showResetPassword"  (click)="resetPassword()">{{'pnpNewflow.pnpflowErrorMsg' | translate}}</div> -->
          <div *ngIf="message" class="successmsg align-center">{{'updateprofileComp.updateprofile11' | translate}}
          </div>
          <!-- <div class="Errormsg align-center" *ngIf="serverError">{{serverError}}</div> -->
      </div>
  </div>
    </ng-container>
    <div *ngIf="paymentProcessStep === 'step1'" class="h-modal__with_footer" id="pnp-modal-body-content">
      <div class="h-modal__body">
        <app-cashier-banner *ngIf="callingFrom != 'withdraw'" [zoneId]="cashierBannerZoneid"></app-cashier-banner>
      <ng-container *ngIf="isPnpFlow">
          <!-- Brite Play Design -->
          <div class="brite__balance">

            <div class="brite__balance--panel">
              <div class="brite__balance--head">
                <h3 *ngIf="callingFrom=='deposit'">{{'britePlayCashier.topupYourBalance' | translate}}</h3>
                <h3 *ngIf="callingFrom=='withdraw'">{{'britePlayCashier.topupYourBalanceWithdraw' | translate}}</h3>
                <p>{{'britePlayCashier.buyCryptoCard' | translate}}</p>
  
                <div class="brite_logo">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/brite_logo.svg" />
                </div>
              </div>
              <div class="brite__balance--payment--logos">
                <span class="icon--bank1">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/bank1_{{countryIP}}.svg" />
                </span>
                <span class="icon--bank2">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/bank2_{{countryIP}}.svg" />
                </span>
                <span class="icon--bank3">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/bank3_{{countryIP}}.svg" />
                </span>
                <span class="icon--bank4">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/bank4_{{countryIP}}.svg" />
                </span>
                <span class="icon--bank5">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/bank5_{{countryIP}}.svg" />
                </span>
                <span class="icon--bank6">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/bank6_{{countryIP}}.svg" />
                </span>
                <span class="icon--bank7">
                  <img src="{{siteUrlPath}}/{{mediaPath}}/brite_logo/bank7_{{countryIP}}.svg" />
                </span>
              </div>
            </div>
          
          </div>
          <div class="brite__choose--amount">
            <div class="brite__heading">
              <h2>{{'britePlayCashier.chooseAmount' | translate}}</h2>
            </div> 
            <div class="brite__choose--amount--panel">
              <div class="brite__choose--amount--input">
                <div class="brite-center">                  
                  <span class="brite--currency-symbol symbol-left" *ngIf='isCurrencyDefaultPosition'>{{currencySymbol}}</span>
                  <div (focus)="showCaret($event)" #inpuRef id="inputAmount" class="input-content-editable"  inputmode="decimal" contenteditable="true" [callingFrom]="callingFrom" appTwoDigitDecimaNumber (input)="checkMaxValue($event)" >{{depositAmount}}</div>
                  <span class="brite--currency-symbol symbol-right" *ngIf='!isCurrencyDefaultPosition'>{{currencySymbol}}</span>
                </div>
              </div>
              <div class="brite__choose--amount--items">
                <button class="site-btn site__hosted--btn" [ngClass]="depositAmount == valueOne*multipleValue ? 'active':''"  (click)="customAmountSet(inpuRef,valueOne * multipleValue)">{{getValueForTab(valueOne)}}</button>
                <button class="site-btn site__hosted--btn" [ngClass]="depositAmount == valueTwo*multipleValue ? 'active':''" (click)="customAmountSet(inpuRef,valueTwo * multipleValue)">{{getValueForTab(valueTwo)}}</button>
                <button class="site-btn site__hosted--btn" [ngClass]="depositAmount == valueThree*multipleValue ? 'active':''" (click)="customAmountSet(inpuRef,valueThree * multipleValue)">{{getValueForTab(valueThree)}}</button>
              </div>
            </div>
            <!-- <p>{{'britePlayCashier.disclaimerTxt' | translate}} </p> -->
            <!-- <div class="brite__btn" (click)="moveToTrustlyLogin()">
              {{'britePlayCashier.loginWith' | translate}}
              <img src="{{siteUrlPath}}/{{mediaPath}}/brite__pay--logo/brite_logo.png" />
            </div> -->
            <div class="pnp-accept-info" *ngIf="callingFrom === 'deposit' && termsAndCondtionsInfo">
              <p class="text-left" [innerHTML]="termsAndCondtionsInfo | safeHtml"></p>
            </div>
          </div>
      </ng-container>
      <ng-container *ngIf="isSemiPnp || isZimplerPnp">
        <!-- zimpler Play Design -->
        <div class="brite__balance zimpler">

          <div class="brite__balance--panel">
            <div class="brite__balance--head">
              <h3 *ngIf="callingFrom=='deposit'">{{'zimplerPlayCashier.topupYourBalance' | translate}}</h3>
              <h3 *ngIf="callingFrom=='withdraw'">{{'zimplerPlayCashier.topupYourBalanceWithdraw' | translate}}</h3>
              
              <p>{{'zimplerPlayCashier.zimplerCard' | translate}}</p>

              <div class="brite_logo noBg">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/zimpler_logo.svg" />
              </div>
            </div>
            <div class="brite__balance--payment--logos">
              <span class="icon--bank1">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/bank1_{{countryIP}}.svg" />
              </span>
              <span class="icon--bank2">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/bank2_{{countryIP}}.svg" />
              </span>
              <span class="icon--bank3">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/bank3_{{countryIP}}.svg" />
              </span>
              <span class="icon--bank4">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/bank4_{{countryIP}}.svg" />
              </span>
              <span class="icon--bank5">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/bank5_{{countryIP}}.svg" />
              </span>
              <span class="icon--bank6">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/bank6_{{countryIP}}.svg" />
              </span>
              <span class="icon--bank7">
                <img src="{{siteUrlPath}}/{{mediaPath}}/zimpler_logo/bank7_{{countryIP}}.svg" />
              </span>
            </div>
          </div>
        
        </div>
        <div class="brite__choose--amount">
          <div class="brite__heading">
            <h2>{{'zimplerPlayCashier.chooseAmount' | translate}}</h2>
          </div> 
          <div class="brite__choose--amount--panel">
            <div class="brite__choose--amount--input">
              <div class="brite-center">
                <span class="brite--currency-symbol symbol-left" *ngIf='isCurrencyDefaultPosition'>{{currencySymbol}}</span>
                <div (focus)="showCaret($event)" #inpuRef id="inputAmount"   inputmode="decimal"  class="input-content-editable" contenteditable="true" [callingFrom]="callingFrom" appTwoDigitDecimaNumber (input)="checkMaxValue($event,event)" >{{depositAmount}}</div>
                <span class="brite--currency-symbol symbol-right" *ngIf='!isCurrencyDefaultPosition'>{{currencySymbol}}</span>
              </div>
            </div>
            <div class="brite__choose--amount--items">
              <button class="site-btn site__hosted--btn" [ngClass]="depositAmount == valueOne*multipleValue ? 'active':''"  (click)="customAmountSet(inpuRef,valueOne * multipleValue)">{{getValueForTab(valueOne)}}</button>
              <button class="site-btn site__hosted--btn" [ngClass]="depositAmount == valueTwo*multipleValue ? 'active':''" (click)="customAmountSet(inpuRef,valueTwo * multipleValue)">{{getValueForTab(valueTwo)}}</button>
              <button class="site-btn site__hosted--btn" [ngClass]="depositAmount == valueThree*multipleValue ? 'active':''" (click)="customAmountSet(inpuRef,valueThree * multipleValue)">{{getValueForTab(valueThree)}}</button>
            </div>
          </div>
          <!-- <p>{{'britePlayCashier.disclaimerTxt' | translate}} </p> -->
          <!-- <div class="brite__btn" (click)="moveToTrustlyLogin()">
            {{'britePlayCashier.loginWith' | translate}}
            <img src="{{siteUrlPath}}/{{mediaPath}}/brite__pay--logo/brite_logo.png" />
          </div> -->
          <div class="pnp-accept-info" *ngIf="callingFrom === 'deposit' && termsAndCondtionsInfo">
            <p class="text-left" [innerHTML]="termsAndCondtionsInfo | safeHtml"></p>
          </div>
        </div>
    </ng-container>
    <div class="transaction_break_down" *ngIf="callingFrom == 'withdraw' && feesInfo.feeType != 'none' && transactionFee && depositAmount">
      <h5 class="break--heading">{{'paymentFieldsComp.transactionBreakdown' | translate}}</h5>
    <div class="deposit__breakdown">
      <p class="flex_spacebetween">
        <span>{{'paymentFieldsComp.initialAmount' | translate}}</span>
        <span class="pull-right">{{ depositAmount | currencyPipe}}</span>
      </p>
        <p class="flex_spacebetween">
          <span>{{'paymentFieldsComp.serviceFee' | translate}}</span>
          <span class="pull-right">-{{ (transactionFee && depositAmount ? transactionFee : 0) | currencyPipe}}</span>
        </p>
        <p class="flex_spacebetween">
          <span>{{'paymentFieldsComp.total' | translate}}</span>
          <span class="pull-right">{{ getTotalAmount() | currencyPipe}}</span>
        </p>
    </div>
    </div>

      </div>
    </div>
    <ng-container *ngIf="paymentProcessStep==='step2'">
      <div class="zimplerIframeContainer zimplerIframeWinodow" id="zimpleriframecontainer" [ngClass]="(isSemiPnp || isZimplerPnp) ? 'show-brite':'hide-brite'"></div>
      <div class="zimplerIframeContainer" id="briteplayIframeContainer" *ngIf="isPnpFlow"  [ngClass]=" isLoadingBrite ? 'hide-brite':'show-brite'"></div>
    </ng-container>
    <ng-container *ngIf="paymentProcessStep === 'step3' || isLoadingBrite">
      <div class="zimplerLoader">
        <div class="loader">
          <div class="loader-inner"></div>
        </div>

        <p>{{'zimpler.paymentProgressMessage' | translate}}</p>
      </div>
    </ng-container>
    <ng-container *ngIf="paymentProcessStep === 'step4'">
      <div class="zimpler_payment">
        <div class="zimpler_payment--success text-success text-center " *ngIf="transactionSuccessMessage">
          <p>{{transactionSuccessMessage}}</p>
        </div>
        <div class="zimpler_payment--danger text-danger text-center" *ngIf="transactionErrorMessage">
          <p>{{transactionErrorMessage}}</p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="paymentProcessStep != 'semiPnpFlow'">
      <div *ngIf="(paymentProcessStep === 'step1') && callingFrom === 'deposit'"
      class="h-modal__footer flex_verticalalign flex_justifyCenter">
      <ng-container *ngIf="isUserLoggedIn">
        <button class="prefer_btn site-btn site-btn__primary site-btn--lg brite--btn" (click)="openStepTwo()" *ngIf="isSemiPnp || isZimplerPnp"
        [disabled]=" !checkAmountIsValid()">
       {{'zimplerDeposit.Deposit_button' | translate}} {{depositAmount | currencyPipe }}
       <ng-container *ngIf="isPnpFlow">{{'briteDeposit.Deposit_button' | translate}}  {{depositAmount | currencyPipe }} </ng-container>
      </button>
      <button class="prefer_btn site-btn site-btn__primary site-btn--lg brite--btn" (click)="openStepTwo()" *ngIf="isPnpFlow"
        [disabled]=" !checkAmountIsValid()">
       {{'briteDeposit.Deposit_button' | translate}} {{depositAmount | currencyPipe }} 
      </button>
      </ng-container>

      <ng-container *ngIf="!isUserLoggedIn">
        <button class="prefer_btn site-btn site-btn__primary site-btn--lg brite--btn" (click)="openStepTwo()" *ngIf="isSemiPnp || isZimplerPnp"
        [disabled]=" !checkAmountIsValid()">
       {{'zimplerDeposit.Deposit_button' | translate}}  {{currencySymbol}} {{depositAmount | number:'1.2-2'}}
       <ng-container *ngIf="isPnpFlow">{{'briteDeposit.Deposit_button' | translate}} {{currencySymbol}} {{depositAmount| number:'1.2-2'}} </ng-container>
      </button>
      <button class="prefer_btn site-btn site-btn__primary site-btn--lg brite--btn" (click)="openStepTwo()" *ngIf="isPnpFlow"
        [disabled]=" !checkAmountIsValid()">
       {{'briteDeposit.Deposit_button' | translate}} {{currencySymbol}} {{depositAmount| number:'1.2-2'}} 
      </button>
      </ng-container>
    </div>

    <div *ngIf="(paymentProcessStep === 'step1' && callingFrom === 'withdraw')"
      class="h-modal__footer flex_verticalalign flex_justifyCenter">
      <button class="prefer_btn site-btn site-btn__primary site-btn--lg brite--btn" (click)="zimplerPNPWithDrawInit()"
        [disabled]="isButtonLoader ||  !checkAmountIsValid() || withdrawalBalance < depositAmount|| !checkForValidTotal()">
        <ng-container *ngIf="(isSemiPnp|| isZimplerPnp) && !isUserLoggedIn"> {{'zimplerDeposit.WithDraw_button' | translate}} {{currencySymbol}} {{depositAmount | number:'1.2-2'}}</ng-container>
        <ng-container *ngIf="isPnpFlow && !isUserLoggedIn"> {{'briteDeposit.WithDraw_button' | translate}} {{currencySymbol}} {{depositAmount | number:'1.2-2'}}</ng-container>
        <ng-container *ngIf="(isSemiPnp|| isZimplerPnp) && isUserLoggedIn"> {{'zimplerDeposit.WithDraw_button' | translate}}  {{depositAmount | currencyPipe }}</ng-container>
        <ng-container *ngIf="isPnpFlow&& isUserLoggedIn"> {{'briteDeposit.WithDraw_button' | translate}} {{depositAmount | currencyPipe}}</ng-container>
      </button>
    </div>
    </ng-container>
  </div>
</modal>